export const RECAPTCHA_SITE_KEY = "6LcLEMgnAAAAACrjVXfw3xGjvDMaX47dw6csDpHk";

export const getDeviceInfo = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("edg")) return "Microsoft Edge";
    if (userAgent.includes("firefox")) return "Mozilla Firefox";
    if (userAgent.includes("safari") && !userAgent.includes("chrome")) return "Safari";
    if (userAgent.includes("opr")) return "Opera";
    if (userAgent.includes("chrome") && !userAgent.includes("edg") && !userAgent.includes("opr")) return "Google Chrome";

    return "N/A";
};

export const getDeviceOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("windows")) return "Windows";
    if (userAgent.includes("macintosh")) return "MacOS";
    if (userAgent.includes("android")) return "Android";
    if (userAgent.includes("iphone")) return "iPhone";
    if (userAgent.includes("linux")) return "Linux";

    return "N/A";
};

export const buildLoginData = ({username, password}, extra = {}) => {
    const data = {
        username: username ?? "",
        password: password ?? "",
        client_id: "SENTRYWEB",
        device_os: getDeviceOS(),
        device_info: getDeviceInfo(),
    };

    Object.entries(extra).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            data[key] = value;
        }
    });

    return data;
};

export const translateServerErrorMessage = (message) => {
    switch (message) {
        case "invalid.login": return "Usuário inválido.";
        case "invalid.hash": return "Código inválido.";
        case "invalid.password": return "A senha não atende aos requisitos de segurança.";
        case "invalid.new.password": return "Nova senha não pode ser igual a atual.";
        default: return "Não foi possível iniciar o processo.";
    }
};

export const translateDestinationMessage = (message) => {
    switch (message) {
        case "invalid.phone": return "Você receberá um SMS no telefone cadastrado.";
        case "invalid.email": return "Você receberá um e-mail no endereço cadastrado.";
        default: return message;
    }
};

export const downloadAnyDesk = () => {
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = getDeviceOS() === "Windows"
        ? "https://download.anydesk.com/AnyDesk.exe"
        : "https://download.anydesk.com/linux/anydesk-latest-amd64.tar.gz";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
